import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { useAccount } from './../../contexts/Account';
import eventBus, { eventBusValues } from './../../eventBus';
import { ReactComponent as PaperPlusIcon } from './../../icons/paper-plus.svg';
import { ReactComponent as CalendarCheckIcon } from './../../icons/calendar-check.svg';
import { ReactComponent as BooksIcon } from './../../icons/books.svg';
import Footer from './Footer';
import BoardTile from '../../components/BoardTile';
import BoardroomActivity from '../../components/BoardroomActivity';
import TopSection from '../../components/Company/TopSection';
import BoardStats from './BoardStats';
import { getCompanyActivity } from '../../services/company_services';
import ACSnackbar from '../../components/ACSnackbar';

const tileTitleStyle = {
  fontSize: { xxs: 16, xs: 20 },
  lineHeight: { xxs: '20px', xs: '26px' },
  fontWeight: '600',
  marginBottom: { xxs: '7px', xs: '14px' },
  textAlign: 'left',
};

const tileDescriptionStyle = {
  fontSize: 12,
  lineHeight: '18px',
  fontWeight: '400',
  color: '#4D586F',
  textAlign: 'left',
};

export default function CompanyDashboardV2() {
  const { accountDetails } = useAccount();
  const history = useHistory();
  const [activities, setActivities] = useState([]);
  const [activitiesSnackBarOpen, setActivitiesSnackBarOpen] = useState(false);

  useEffect(() => {
    getCompanyActivity({
      companyId: accountDetails.id,
      filterType: ['advisorJoinedToCompany', 'surveyResponse', 'advisorIdea'],
    })
      .then((response) => {
        setActivities(response.data.getCompanyActivity || []);
      })
      .catch((error) => {
        console.error('Error fetching company activity:', error);
      });
  }, [accountDetails.id]);

  function seeOpportunity() {
    eventBus.dispatch(eventBusValues.triggerCompanyDrawerAction, {
      company: accountDetails,
    });
  }

  return (
    <>
      <Box sx={{ p: { xxs: 2, xs: 4 }, backgroundColor: '#F4F8FF' }}>
        <TopSection />
        <Grid container spacing={2} sx={{ mt: 0, mb: 2 }}>
          <Grid item xxs={12} md={6}>
            <BoardStats />
          </Grid>
          <Grid item xxs={12} md={6}>
            <BoardroomActivity
              company={accountDetails}
              id="dashboard-boardroom-activity"
              showEmptyState
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <BoardTile
            id="dashboard-background-materials"
            image={<BooksIcon style={{ width: 90, height: 90 }} />}
            onClick={() => seeOpportunity(accountDetails?.id)}
          >
            <Typography sx={tileTitleStyle}>Background Materials</Typography>
            <Typography sx={tileDescriptionStyle}>
              Enable your advisors to learn more about you, your goals, benefits
              for board members, and anything else related to your advisory
              board.
            </Typography>
          </BoardTile>
          <BoardTile
            id="dashboard-board-members"
            image={<CalendarCheckIcon style={{ width: 60, height: 60 }} />}
            onClick={() => history.push(`/advisors`)}
          >
            <Typography sx={tileTitleStyle}>Board Members</Typography>
            <Typography sx={tileDescriptionStyle}>
              View current advisors, invite your contacts, search the advisor
              directory and see how easy it is to grow your advisory board.
            </Typography>
          </BoardTile>

          <BoardTile
            id="dashboard-boardroom-activity-box"
            image={<CalendarCheckIcon style={{ width: 60, height: 60 }} />}
            onClick={() => {
              if (activities.length > 0) {
                history.push(`/board_activity`);
              } else {
                setActivitiesSnackBarOpen(true);
              }
            }}
          >
            <Typography sx={tileTitleStyle}>Boardroom Activity</Typography>
            <Typography sx={tileDescriptionStyle}>
              View the full log of boardroom activity, advisory board
              announcements and favorite ideas shared in the boardroom.
            </Typography>
          </BoardTile>

          <BoardTile
            id="dashboard-get-assistance"
            image={<PaperPlusIcon style={{ width: 60, height: 60 }} />}
            onClick={() => {}}
          >
            <Typography sx={tileTitleStyle}>Get Assistance</Typography>
            <Typography sx={tileDescriptionStyle}>
              Reach out to our team to get assistance and answer any questions
              related to your advisory board.
            </Typography>
          </BoardTile>
        </Grid>
        <Footer />
      </Box>
      <ACSnackbar
        open={activitiesSnackBarOpen}
        text="No Boardroom Activity Yet! Invite more advisors to your board."
        severity="success"
        onClose={() => setActivitiesSnackBarOpen(false)}
        autoHideDuration={5000}
      />
    </>
  );
}
